var alertTriggerToggle = {
	add: "Activeringsparameter bewerken",
	edit: "Activeringsparameter toevoegen",
	label: {
		addAlert: "Alarm toevoegen",
		upperLimit: "Bovengrens",
		lowerLimit: "Ondergrens",
		upperLimitCrossed: "Bovengrens overschreden",
		lowerLimitCrossed: "Ondergrens overschreden"
	}
};
var nl = {
	alertTriggerToggle: alertTriggerToggle
};

export { alertTriggerToggle, nl as default };
